import { render, staticRenderFns } from "./LocationsSelector.vue?vue&type=template&id=cbc977b8&"
import script from "./LocationsSelector.vue?vue&type=script&lang=js&"
export * from "./LocationsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports